import styled from "styled-components";

export const SiteFooterWrapper = styled.div`
  height: 5vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top: 2px solid black;
  width: 100vw;
  padding: 5px;
`;
